import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultSignageIf } from '../interfaces/SignageIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C702SignageAddProps {
  execSignageAdd: (signage_name: string, file: File, signed_url: string) => Promise<ResultSignageIf>
  loading: loadStatus
}
// C702 サイネージ登録API呼出
export const useC702SignageAdd = (): C702SignageAddProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execSignageAdd = async (signage_name: string, file: File, signed_url: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      // ボディ作成
      const body = {
        signage_name: signage_name,
        language: 'ja',
        file_name: file.name,
        url: signed_url,
      }
      // console.log(body);

      const response = await axios.post(
        buildDeviceUrl(auth.deviceId, apiUrl.signagesPath),
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execSignageAdd, loading }
}
